import type { ReactNode } from 'react';
import { LightRibbonMark } from './LightRibbonMark';
import { WordPulse } from './WordPulse';
import './redesign.css';

interface HeroHeaderProps {
  visible: boolean;
  isDesktop: boolean;
  welcome: ReactNode;
}

/** A dimensional light ribbon accompanies the community wordmark. */
export const HeroHeader = ({ visible, isDesktop, welcome }: HeroHeaderProps) => (
  <header
    className={`max-w-6xl mx-auto px-1 sm:px-4 mb-6 sm:mb-10 transition-[opacity,transform] duration-700 ${
      visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
    }`}
  >
    <div className="flex items-center justify-center">
      <div className="min-w-0 flex flex-col items-center text-center">
        <p lang="en" dir="ltr" className="rd-mono mb-3 flex items-center justify-center gap-3 whitespace-nowrap text-[10px] tracking-[.3em] text-[#8FA0C8]/80 sm:text-[11px]">
          ISRAEL&nbsp;·&nbsp;AI&nbsp;COMMUNITY
          <span className="h-px w-8 bg-[#8FA0C8]/40" />
        </p>
        <h1 lang="en" className="sr-only">nVision Digital AI</h1>
        <div className="flex items-center justify-center gap-2 sm:gap-4" dir="ltr">
          <LightRibbonMark size={isDesktop ? 148 : 76} />
          <WordPulse fontPx={isDesktop ? 52 : 22} />
        </div>
        <p className={`mt-3 sm:mt-5 max-w-[64ch] text-center leading-[1.7] sm:leading-[1.8] text-white/65 ${isDesktop ? 'text-[17.5px]' : 'text-[15px] sm:text-[16px]'}`}>
          {welcome}
        </p>
      </div>
    </div>
  </header>
);
